import Icomessage from "../../assets/img/ico-message.svg";

const MessageLink = () => {

    return (

        <div style={{ visibility: "hidden" }} className="_message-box d-none d-lg-flex">
            <a href="#">
                <img src={Icomessage} alt="Ícone de mensagem" />
            </a>
        </div>
    )
};
export default MessageLink;